/* React base class */
import { Component } from "react"

/* Redux store connection */
import { connect } from "react-redux"

/* Router HOC */
import { withRouter, applySeo } from "../helpers"

/* Shared UI components */
import { Block } from "../components"

/* Icon component */
import Icon from "../components/Icon"

/* i18n */
import { translate } from "../translates"

/* Page Page404 */
class Page404 extends Component {

    componentDidMount = () => {
        /* SEO */
        applySeo({
            title: "Страница не найдена — Bookify",
            description: "Такой страницы не существует. Вернитесь на главную Bookify, чтобы найти нужный сервис и записаться онлайн.",
            path: window.location.pathname,
            robots: "noindex, follow"
        })
    }

    render = () => {

        /* Fields */
        const { navigate } = this.props

        return (
            <Block>
                <div className="page">
                    <div className="container">
                        <div className="empty">
                            <div className="empty__art"><Icon name="search" size={48} /></div>
                            <h3>{translate("Страница не найдена")}</h3>
                            <p>{translate("Возможно, ссылка устарела или страница была удалена.")}</p>
                            <button className="btn" onClick={() => navigate("/")}>{translate("На главную")}</button>
                        </div>
                    </div>
                </div>
            </Block>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        lang: state.lang
    }
}

/* Export */
export default connect(mapStateToProps)(withRouter(Page404))
